<h1 matDialogTitle>{{ credential.id }}</h1>
<mat-dialog-content>
  <pre><code [highlight]="credential | json"></code></pre>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
